import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';

@Component({
  selector: 'app-nominative-rds',
  templateUrl: './nominative-rds.component.html',
  styleUrls: ['./nominative-rds.component.scss'],
  standalone: false
})
export class NominativeRdsComponent implements OnInit, OnDestroy {

  sourceName: string = '';
  collectionName: string = '';

  // Primary Key info
  primaryKeyFields: string[] = [];
  primaryKeySeparator: string = '';
  primaryKeyComposed: string = '';

  // Alternate Keys info
  alternateKeyFields: string[] = [];

  private primaryKeySub: Subscription;
  private menuSub: Subscription;

  constructor(
    public localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    // Intentar cargar el nombre de la fuente inmediatamente
    this.loadSourceName();

    // Suscribirse a cambios de menú seleccionado para obtener el nombre de la fuente
    this.menuSub = this.localStorageService.getMenuSelectedObs.subscribe(menu => {
      if (menu) {
        this.sourceName = menu.subDomainJO || '';
        this.collectionName = menu.domainJO
          ? `${menu.domainJO} / ${menu.subDomainJO}`
          : menu.subDomainJO || '';
      }
    });

    // Suscribirse a cambios de primary key - cuando se emite, los fields ya están cargados
    this.primaryKeySub = this.localStorageService.getPrimaryKeyFieldRDS$.subscribe(value => {
      if (value) {
        this.primaryKeyComposed = value;
        this.loadFieldsInfo();
        // También intentar cargar el nombre si aún no se tiene
        if (!this.sourceName) {
          this.loadSourceName();
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.primaryKeySub) {
      this.primaryKeySub.unsubscribe();
    }
    if (this.menuSub) {
      this.menuSub.unsubscribe();
    }
  }

  private loadSourceName(): void {
    const dataSource = this.localStorageService.getDataSourceSelected;
    if (dataSource) {
      this.sourceName = dataSource.subDomainJO || '';
      this.collectionName = dataSource.domainJO
        ? `${dataSource.domainJO} / ${dataSource.subDomainJO}`
        : dataSource.subDomainJO || '';
    }
  }

  private loadFieldsInfo(): void {
    const fields = this.localStorageService.fields;
    if (fields) {
      // Primary Key
      if (fields.primaryKey) {
        this.primaryKeyFields = fields.primaryKey.sourceFields || [];
        this.primaryKeySeparator = fields.primaryKey.separator || '';
        this.primaryKeyComposed = this.primaryKeyFields.join(this.primaryKeySeparator);
      }

      // Alternate Keys
      if (fields.alternateKeys) {
        this.alternateKeyFields = fields.alternateKeys.sourceFields || [];
      }
    }
  }
}

